module.exports = __webpack_public_path__ + "media/country_flags/hn-39bbd53b.png";